import { Provider } from '@angular/core';

import { EstimateJobHourlyRateService } from '../Domain/Port/EstimateJob/estimate-job-hourly-rate.service';
import { BackendEstimateJobHourlyRateService } from '../Infrastructure/Adapter/backend-estimate-job-hourly-rate.service';

export const provideEstimateJobService = (): Provider[] => {
    return [
        {
            provide: EstimateJobHourlyRateService,
            useExisting: BackendEstimateJobHourlyRateService
        }
    ];
};
